import type { Tone } from 'src/lib/tone';

type NoticeProps = {
  tone: Tone;
  title: string;
  children?: React.ReactNode;
  /** The consumer sets the role — a warning that is not urgent should not shout at a screen reader. */
  role?: 'status' | 'alert';
};

export function Notice({ tone, title, children, role = 'status' }: NoticeProps) {
  return (
    <div className="notice" data-tone={tone} role={role}>
      <p className="notice__title">{title}</p>
      {children && <div className="notice__body">{children}</div>}
    </div>
  );
}
